import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AppDetails from '@/plugins/graphql/queries/v2/ecommerce/app-details.gql';
import { EcommerceAppModel } from '@/helpers/entities/models/EcommerceAppModel';
let AppDetailsMixin = class AppDetailsMixin extends Vue {
    constructor() {
        super(...arguments);
        this.appDetails = null;
        this.appId = 0;
    }
    get checkAppId() {
        return this.appId;
    }
    get subcategorized() {
        const subcategorized = false;
        if (this.appDetails && this.appDetails.setting) {
            return this.appDetails.setting.subcategorized;
        }
        return subcategorized;
    }
    get enableProductLocationAvailability() {
        const locationAvailability = false;
        if (this.appDetails && this.appDetails.setting) {
            return this.appDetails.setting.enableProductLocationAvailability;
        }
        return locationAvailability;
    }
    get appQueryOnFlight() {
        return this.$apollo.queries.appDetails.loading;
    }
    get ordersExportable() {
        let ordersExportable;
        if (this.appDetails) {
            ordersExportable = !this.appDetails.ordersExportable;
        }
        return ordersExportable;
    }
    get rebatable() {
        let rebatable;
        if (this.appDetails) {
            rebatable = !this.appDetails.rebatable;
        }
        return rebatable;
    }
    get referrable() {
        const referrable = false;
        if (this.appDetails) {
            return this.appDetails.referrable;
        }
        return referrable;
    }
    get importableCsv() {
        let importableCsv = false;
        if (this.appDetails) {
            importableCsv = this.appDetails.importableCsv;
        }
        return importableCsv;
    }
    get productTrackable() {
        let productTrackable = false;
        if (this.appDetails) {
            productTrackable = this.appDetails.productTrackable;
        }
        return productTrackable;
    }
    refetchAppDetails() {
        if (this.appDetails) {
            this.$apollo.queries.appDetails.refetch();
        }
    }
    get appliesKyc() {
        let appliesKyc = false;
        if (this.appDetails) {
            appliesKyc = this.appDetails.appliesKyc;
        }
        return appliesKyc;
    }
    get bulkable() {
        let bulkable = false;
        if (this.appDetails) {
            bulkable = this.appDetails.bulkable;
        }
        return bulkable;
    }
    get kioskTracker() {
        let kioskTracker = false;
        if (this.appDetails) {
            kioskTracker = this.appDetails.kioskTracker;
        }
        return kioskTracker;
    }
    get staticForDeliveryFilter() {
        let active = true;
        if (this.appDetails) {
            if (this.appDetails.name === 'Globe Shop Staging' ||
                this.appDetails.name === 'Globe Online Shop') {
                active = false;
            }
        }
        return active;
    }
    get plan() {
        return this.appDetails?.plan || 'free';
    }
    get newProTierType() {
        return this.appDetails?.newProTierType || 'basic';
    }
    get allowAdvanceOrder() {
        let allowAdvanceOrder = false;
        if (this.appDetails) {
            allowAdvanceOrder = this.appDetails.allowAdvanceOrder;
        }
        return allowAdvanceOrder;
    }
    get withShippingParkAndMunch() {
        let withShippingParkAndMunch = false;
        if (this.appDetails) {
            withShippingParkAndMunch = this.appDetails.withShippingParkAndMunch;
        }
        return withShippingParkAndMunch;
    }
    get withLalamoveShipping() {
        let withLalamoveShipping = false;
        if (this.appDetails) {
            withLalamoveShipping = this.appDetails.withLalamoveShipping;
        }
        return withLalamoveShipping;
    }
    get insurance() {
        if (this.appDetails) {
            return this.appDetails?.insurance;
        }
        return false;
    }
    get distributorId() {
        let distributorId;
        if (this.appDetails) {
            distributorId = this.appDetails.distributorId;
        }
        return distributorId;
    }
    get assignedLocationIds() {
        let assignedLocationIds = [];
        if (this.appDetails) {
            assignedLocationIds = this.appDetails.assignedLocationIds;
        }
        return assignedLocationIds;
    }
    get sunLife() {
        if (this.appDetails) {
            return this.appDetails?.sunLife;
        }
        return false;
    }
    get appEmailNotificationRecipientsList() {
        let emailNotificationRecipientsList = [];
        if (this.appDetails) {
            emailNotificationRecipientsList = this.appDetails.emailNotificationRecipientsList;
        }
        return emailNotificationRecipientsList;
    }
};
__decorate([
    Getter('appUuid')
], AppDetailsMixin.prototype, "appUuid", void 0);
AppDetailsMixin = __decorate([
    Component({
        apollo: {
            appDetails: {
                query: AppDetails,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    this.appId = data?.ecommerceAppDetails?.id;
                    return new EcommerceAppModel(data.ecommerceAppDetails);
                },
                fetchPolicy: 'cache-and-network',
            },
        },
    })
], AppDetailsMixin);
export default AppDetailsMixin;
